import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaCheck, FaArrowRight } from "react-icons/fa";

const ThankYou = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const orderNumber = queryParams.get("order_number") || "---";
  return (
    <PageWrapper>
      <DispatchCard>
        <PerforatedEdge />

        <CardBody>
          <CardHeader>
            <Wordmark>MARKITI</Wordmark>
            <DocLabel>ORDER RECEIPT</DocLabel>
          </CardHeader>

          <StampWrapper>
            <Stamp>
              <FaCheck size={22} color="#00A89A" />
              <StampLabel>CONFIRMED</StampLabel>
            </Stamp>
          </StampWrapper>

          <Headline>Asante! Your order is confirmed</Headline>
          <OrderRow>
            <OrderLabel>Order no.</OrderLabel>
            <OrderCode>{orderNumber}</OrderCode>
          </OrderRow>

          <ContinueShoppingBtn onClick={() => history.push("/")}>
            <span>Back to products</span>
            <FaArrowRight size={14} />
          </ContinueShoppingBtn>
        </CardBody>

        <PerforatedEdge />
      </DispatchCard>
    </PageWrapper>
  );
};

export default ThankYou;

const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #eeece4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  box-sizing: border-box;
`;

const DispatchCard = styled.div`
  background: #faf8f3;
  max-width: 400px;
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
`;

/* Perforation effect: a strip of circular cutouts matching the page background */
const PerforatedEdge = styled.div`
  height: 14px;
  width: 100%;
  background-image: radial-gradient(
    circle at 10px 7px,
    #eeece4 6px,
    transparent 6.5px
  );
  background-size: 20px 14px;
  background-position: 0 0;
`;

const CardBody = styled.div`
  padding: 0.5rem 2rem 2.5rem;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.25rem;
`;

const Wordmark = styled.span`
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.12em;
  color: #494395;
  font-weight: 500;
`;

const DocLabel = styled.span`
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  color: #8b87b0;
`;

const StampWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.75rem;
`;

const Stamp = styled.div`
  width: 92px;
  height: 92px;
  border-radius: 50%;
  border: 2px dashed #00a89a;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transform: rotate(-9deg);
  box-sizing: border-box;
`;

const StampLabel = styled.div`
  font-family: "IBM Plex Mono", monospace;
  font-size: 9px;
  letter-spacing: 0.1em;
  color: #00a89a;
  margin-top: 2px;
`;

const Headline = styled.h1`
  font-family: "Space Grotesk", sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #2a2650;
  text-align: center;
  margin: 0 0 2rem;
  letter-spacing: -0.01em;
`;

const OrderRow = styled.div`
  border-top: 1.5px dashed #d8d4c8;
  border-bottom: 1.5px dashed #d8d4c8;
  padding: 1rem 0;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OrderLabel = styled.span`
  font-size: 12px;
  letter-spacing: 0.06em;
  color: #8b87b0;
  text-transform: uppercase;
`;

const OrderCode = styled.span`
  font-family: "IBM Plex Mono", monospace;
  font-size: 15px;
  font-weight: 500;
  color: #494395;
  background: #ffe600;
  padding: 3px 10px;
  border-radius: 3px;
  word-break: break-all;
`;

const ContinueShoppingBtn = styled.button`
  width: 100%;
  background: #494395;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 0.95rem;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  transition: background 0.15s ease;

  &:hover {
    background: #3c3675;
  }

  &:active {
    transform: scale(0.99);
  }
`;
